var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "pa-4",
      attrs: { role: "region", "aria-labelledby": "cancelled-heading" },
    },
    [
      _vm.hasOrder
        ? _c(
            "v-alert",
            {
              attrs: {
                color: "warning",
                type: "warning",
                icon: "priority_high",
                "aria-live": "assertive",
                border: "left",
                dense: "",
              },
            },
            [
              _c(
                "h2",
                { staticClass: "sr-only", attrs: { id: "cancelled-heading" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("components.checkout.cancelled")) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("components.checkout.cancelled"))),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }